import { Component } from '@angular/core';
import { NbLoginComponent, NbAuthResult } from '@nebular/auth';
import {Md5} from 'ts-md5/dist/md5';


@Component({
  selector: 'ngx-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent extends NbLoginComponent {


  smartlogin(): void {
    console.log("Vamos a loguear al usuario");
    const md5 = new Md5();
    this.errors = [];
    this.messages = [];
    this.submitted = true;
    console.log("Convertimos a md5 "+this.user.password+"-");
    var userpayload = Object.assign({},this.user);

    userpayload.password = md5.appendStr(this.user.password).end();

    this.service.authenticate(this.strategy, userpayload).subscribe((result: NbAuthResult) => {
      this.submitted = false;

      if (result.isSuccess()) {
        this.messages = result.getMessages();
      } else {
        this.errors = result.getErrors();
      }

      const redirect = result.getRedirect();
      if (redirect) {
        setTimeout(() => {
          return this.router.navigateByUrl(redirect);
        }, this.redirectDelay);
      }
      this.cd.detectChanges();
    });
  }

}
